import { NavLink } from 'react-router-dom';
import { IconToday, IconHistory, IconCoach, IconMore } from './icons';

const TABS = [
  { to: '/', label: 'Today', Icon: IconToday, end: true },
  { to: '/analysis', label: 'Analysis', Icon: IconHistory, end: false },
  { to: '/coach', label: 'Coach', Icon: IconCoach, end: false },
  { to: '/more', label: 'More', Icon: IconMore, end: false },
];

export function Nav() {
  return (
    <nav className="nav">
      <div className="nav-inner">
        {TABS.map(({ to, label, Icon, end }) => (
          <NavLink key={to} to={to} end={end} className={({ isActive }) => (isActive ? 'active' : '')}>
            <Icon className="ico" />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
